import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var DeleteComponent = (function () {
    function DeleteComponent(_data, _utils, _blogic) {
        this._data = _data;
        this._utils = _utils;
        this._blogic = _blogic;
        this.enableDeleteButton = false;
        this.destroy$ = new Subject();
    }
    DeleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._selectedUpdateTurn(this._data.selectedTurn);
        this._data.selectedTurnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._selectedUpdateTurn(response);
        });
    };
    DeleteComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    DeleteComponent.prototype.deleteTurn = function () {
        var params = [];
        params = {
            turn_id: this._data.selectedTurn["id"]
        };
        this._blogic.deleteTurn(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            $("#refreshList").trigger('click');
        });
    };
    /* When the turn information change */
    DeleteComponent.prototype._selectedUpdateTurn = function (selectedTurn) {
        if (selectedTurn != null && (selectedTurn['type'] == 'inWait' || selectedTurn['type'] == 'noShow' || selectedTurn['type'] == 'cancelled')) {
            this.enableDeleteButton = true;
        }
        else {
            this.enableDeleteButton = false;
        }
    };
    return DeleteComponent;
}());
export { DeleteComponent };
